import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './informesGestionFinanciera.css';

  const InformesGestionFinanciera = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className='container'>
        <div className='row'>
            <div className='ldf_titulo'>
                <h2>Integración y Rendición de Informes de Gestión Financiera Consolidada</h2>
                <hr className='hr-gob'/>
            </div>

            <table className="table table-striped table-bordered tabla_elementos">
                <tbody>
                    <tr>
                        <td>2018</td>
                        <td>2019</td>
                        <td>2020</td>
                        <td>2021</td>
                        <td><h3><Link to="DetalleInformesGestionFinanciera/DetalleInformesGestionFinanciera2022">2022</Link></h3></td>
                    </tr>
                    <tr>
                        <td><h3><Link to="DetalleInformesGestionFinanciera/DetalleInformesGestionFinanciera2023">2023</Link></h3></td>
                        <td><h3><Link to="DetalleInformesGestionFinanciera/DetalleInformesGestionFinanciera2024">2024</Link></h3></td>
                        <td><h3><Link to="DetalleInformesGestionFinanciera/DetalleInformesGestionFinanciera2025">2025</Link></h3></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
         </div>
     </div>
     )
}

export default InformesGestionFinanciera